import React from "react";

const AddAddress = ({ handleChange, handleSubmit }) => {
  return (
    <div className="font-sans">
      <div className="lg:my-4 md:my-4 w-full m-auto">
        <form onSubmit={handleSubmit}>
          <div className="border-4 border-black dark:border-white/30 shadow-[12px_12px_0px_0px_rgba(0,0,0,1)] dark:shadow-[12px_12px_0px_0px_rgba(255,255,255,0.5)] bg-white dark:bg-black relative">
            <div className="px-6 py-8 sm:p-10 border-b-4 border-black dark:border-white/30">
              <div className="grid grid-cols-6 gap-8">
                <div className="col-span-6">
                  <label
                    htmlFor="street-address"
                    className="block text-[10px] font-mono uppercase tracking-widest font-bold text-gray-500 dark:text-gray-400 mb-2"
                  >
                    STREET ADDRESS
                  </label>
                  <input
                    type="text"
                    name="street"
                    id="street-address"
                    autoComplete="street-address"
                    placeholder="ENTER STREET DATA..."
                    className="w-full resize-none outline-none bg-transparent text-black dark:text-white font-mono text-xl uppercase font-bold border-b-4 border-black dark:border-white/30 border-dashed focus:border-solid py-2 transition-all placeholder-gray-300 dark:placeholder-gray-700"
                    required
                    onChange={handleChange}
                  />
                </div>

                <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                  <label
                    htmlFor="city"
                    className="block text-[10px] font-mono uppercase tracking-widest font-bold text-gray-500 dark:text-gray-400 mb-2"
                  >
                    CITY
                  </label>
                  <input
                    type="text"
                    name="city"
                    id="city"
                    autoComplete="address-level2"
                    placeholder="DECLARED CITY..."
                    className="w-full resize-none outline-none bg-transparent text-black dark:text-white font-mono text-xl uppercase font-bold border-b-4 border-black dark:border-white/30 border-dashed focus:border-solid py-2 transition-all placeholder-gray-300 dark:placeholder-gray-700"
                    required
                    onChange={handleChange}
                  />
                </div>

                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                  <label
                    htmlFor="region"
                    className="block text-[10px] font-mono uppercase tracking-widest font-bold text-gray-500 dark:text-gray-400 mb-2"
                  >
                    STATE / PROVINCE
                  </label>
                  <input
                    type="text"
                    name="state"
                    id="region"
                    autoComplete="address-level1"
                    placeholder="DEFINE STATE..."
                    className="w-full resize-none outline-none bg-transparent text-black dark:text-white font-mono text-xl uppercase font-bold border-b-4 border-black dark:border-white/30 border-dashed focus:border-solid py-2 transition-all placeholder-gray-300 dark:placeholder-gray-700"
                    required
                    onChange={handleChange}
                  />
                </div>

                <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                  <label
                    htmlFor="postal-code"
                    className="block text-[10px] font-mono uppercase tracking-widest font-bold text-gray-500 dark:text-gray-400 mb-2"
                  >
                    ZIP / POSTAL CODE
                  </label>
                  <input
                    type="text"
                    name="pincode"
                    id="postal-code"
                    autoComplete="postal-code"
                    placeholder="ZIP IDENTIFIER..."
                    className="w-full resize-none outline-none bg-transparent text-black dark:text-white font-mono text-xl uppercase font-bold border-b-4 border-black dark:border-white/30 border-dashed focus:border-solid py-2 transition-all placeholder-gray-300 dark:placeholder-gray-700"
                    required
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="px-6 py-6 sm:px-10 bg-[#f4f4f4] dark:bg-[#111] flex justify-end">
              <button
                type="submit"
                className="px-8 py-3 text-[10px] uppercase font-black tracking-widest text-white dark:text-black bg-black dark:bg-white border-2 border-black dark:border-white/30 hover:bg-green-600 dark:hover:bg-green-500 transition-colors shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] dark:shadow-[4px_4px_0px_0px_rgba(255,255,255,0.5)] hover:shadow-none dark:hover:shadow-none hover:translate-y-1 hover:translate-x-1"
              >
                EXECUTE INSERTION
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddAddress;
